import { ArticleItem } from '../../types';

export const marchTerminatedRegistrationReviewEn: ArticleItem = {
  slug: "march-terminated-registration-review",
  title: "Medical Device Registration Reviews Terminated in March",
  summary: "A March 2026 summary table lists medical device registration review termination notices and related product information.",
  seo: {
    title: "Medical Device Registration Reviews Terminated in March | HL Medical",
    description: "A March 2026 summary table of medical device registration review termination notice delivery information.",
    keywords: "medical device registration termination, medical device registration review, NMPA registration, medical device review notice",
    canonicalUrl: "https://hlmedicalconsult.cn/en/articles/march-terminated-registration-review",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/march-terminated-registration-review",
      cn: "https://hlmedicalconsult.cn/cn/articles/march-terminated-registration-review",
      xDefault: "https://hlmedicalconsult.cn/en/articles/march-terminated-registration-review"
    },
    ogTitle: "Medical Device Registration Reviews Terminated in March",
    ogDescription: "A summary of March 2026 medical device registration review termination notice delivery information.",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "Registration Review",
  readTime: "2 min read",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "March Registration Review Termination Summary" },
    { type: "paragraph", text: "Throughout March, these medical device registration reviews were terminated. Are any of them relevant to your area of focus?" },
    { type: "heading", text: "March 2026 Medical Device Registration Review Termination Notice Delivery Information" },
    {
      type: "table",
      columns: ["No.", "Acceptance No.", "Product Name", "Applicant", "Agent"],
      rows: [
        ["1", "CQX2600366", "Prefilled catheter flusher", "山东裕欣药业有限公司", ""],
        ["2", "CQY2600277", "Calibration angiography catheter", "苏州镭迪生医疗科技有限公司", ""],
        ["3", "CSZ2200342", "Central nervous system infectious pathogen nucleic acid detection kit (reversible terminator sequencing method)", "予果智造科技（北京）有限公司", ""],
        ["4", "CSZ2400514", "Vascular hemophilia factor assay kit (latex immunoturbidimetric method)", "北京九强生物技术股份有限公司", ""],
        ["5", "CQX2501702", "Absorbable hemostatic microspheres", "杭州协合医疗用品有限公司", ""],
        ["6", "JQX2401860", "Absorbable tissue reinforcement material", "Ethicon Endo-Surgery, LLC", "强生（上海）医疗器材有限公司"],
        ["7", "CQX2600159", "Single-use sterile injection device with needle", "江苏赛乐医疗器械有限公司", ""],
        ["8", "CQX2600237", "Real-time fluorescence quantitative PCR instrument", "浙江安吉百伦医疗科技有限公司", ""],
        ["9", "JQX2600181", "Vascular introducer sheath", "Medtronic Inc.", "美敦力（上海）管理有限公司"],
        ["10", "JQX2600217", "Fully automated enzyme immunoassay analyzer", "EUROIMMUN Medizinische Labordiagnostika AG", "欧蒙医学诊断（中国）有限公司"],
        ["11", "JQX2600229", "Bilevel positive airway pressure ventilator", "ResMed Pty Ltd", "瑞思迈（北京）贸易有限公司"],
        ["12", "CQZ24002409", "Ultrasonic soft tissue surgical equipment", "重庆知路者医疗科技有限公司", ""],
        ["13", "CQZ2500120", "Semiconductor laser therapy device", "西安益都医疗电子科技有限公司", ""],
        ["14", "CQZ2600199", "Biological safety cabinet", "上海轩文斯净化设备有限公司", ""],
        ["15", "CSZ2600040", "Herpes simplex virus nucleic acid detection kit (PCR-fluorescent probe method)", "深圳市新产业生物医工程股份有限公司", ""],
        ["16", "CQY2600263", "Single-use sterile auto-disable syringe with needle", "广东因特圣医疗器械有限公司", ""],
        ["17", "CQX2501795", "Medical silicone gel for silicone gel breast implants", "广州迈普再生医学科技股份有限公司", ""],
        ["18", "CSX2600013", "Pneumoniae Klebsiella and three carbapenem resistance gene detection kit (fluorescent PCR method)", "宁波建功生物技术有限公司", ""],
        ["19", "CQZ2401299", "Carotid artery embolic protection stent", "苏州中天医疗器械科技有限公司", ""],
        ["20", "CQZ2401410", "Blastocyst culture medium", "太平洋森赛科学仪器（济南）有限公司", ""],
        ["21", "CQZ2500179", "Soft tissue repair scaffold", "北京天星医疗股份有限公司", ""],
        ["22", "CQZ2502415", "Single-use intravenous blood collection needle", "浙江迈纳士智能诊断科技有限公司", ""],
        ["23", "JQZ2500025", "Soft hydrophilic contact lens", "晶硕光学股份有限公司", "瞳视界生物科技（江苏）有限公司"],
        ["24", "JQX2401457", "Defibrillation monitor", "SCHILLER MEDICAL", "薪火医疗设备（重庆）有限公司"],
        ["25", "CQZ2401241", "Sodium hyaluronate gel for injection", "浙江景兴医疗科技有限公司", ""],
        ["26", "CQZ2401722", "Acetabular joint prosthesis - ball head", "北京市春立正达医疗器械股份有限公司", ""],
        ["27", "CQZ2402377", "PEEK cranial repair system", "江苏艾迪尔医疗科技股份有限公司", ""],
        ["28", "CQZ2500092", "Elastic denture base material", "珠海市科瑞迪医疗科技有限公司", ""],
        ["29", "CQZ2500540", "Prefilled syringe", "山东朱氏药业集团有限公司", ""],
        ["30", "JQZ2400509", "Delta resorbable craniofacial internal fixation system", "Stryker Leibinger GmbH & Co KG", "史赛克（北京）医疗器械有限公司"]
      ]
    }
  ]
};

export const marchTerminatedRegistrationReviewCn: ArticleItem = {
  slug: "march-terminated-registration-review",
  title: "整个3月，这些医疗器械终止注册，有你关心的吗？",
  summary: "2026年3月医疗器械终止注册审查告知书送达信息汇总。",
  seo: {
    title: "整个3月，这些医疗器械终止注册，有你关心的吗？ | 赫莱医药",
    description: "2026年3月医疗器械终止注册审查告知书送达信息汇总表，展示受理号、产品名称、申请人及代理人信息。",
    keywords: "医疗器械终止注册, 医疗器械注册审查, 医疗器械受理号, NMPA注册",
    canonicalUrl: "https://hlmedicalconsult.cn/cn/articles/march-terminated-registration-review",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/march-terminated-registration-review",
      cn: "https://hlmedicalconsult.cn/cn/articles/march-terminated-registration-review",
      xDefault: "https://hlmedicalconsult.cn/en/articles/march-terminated-registration-review"
    },
    ogTitle: "整个3月，这些医疗器械终止注册，有你关心的吗？",
    ogDescription: "2026年3月医疗器械终止注册审查告知书送达信息汇总。",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "注册审查",
  readTime: "约2分钟",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "3月终止注册汇总" },
    { type: "paragraph", text: "整个3月，这些医疗器械终止注册，有你关心的吗？" },
    { type: "heading", text: "2026年3月医疗器械终止注册审查告知书送达信息" },
    {
      type: "table",
      columns: ["序号", "受理号", "产品名称", "申请人", "代理人"],
      rows: [
        ["1", "CQX2600366", "预充式导管冲洗器", "山东裕欣药业有限公司", ""],
        ["2", "CQY2600277", "标测造影导管", "苏州镭迪生医疗科技有限公司", ""],
        ["3", "CSZ2200342", "中枢神经系统感染病原微生物核酸检测试剂盒（可逆末端终止测序法）", "予果智造科技（北京）有限公司", ""],
        ["4", "CSZ2400514", "血管性血友病因子抗测定试剂盒（胶乳免疫比浊法）", "北京九强生物技术股份有限公司", ""],
        ["5", "CQX2501702", "可吸收止血微球", "杭州协合医疗用品有限公司", ""],
        ["6", "JQX2401860", "可吸收组织加固材料", "Ethicon Endo-Surgery, LLC", "强生（上海）医疗器材有限公司"],
        ["7", "CQX2600159", "一次性使用无菌注射器 带针", "江苏赛乐医疗器械有限公司", ""],
        ["8", "CQX2600237", "实时荧光定量PCR仪", "浙江安吉百伦医疗科技有限公司", ""],
        ["9", "JQX2600181", "血管导引鞘", "Medtronic Inc.", "美敦力（上海）管理有限公司"],
        ["10", "JQX2600217", "全自动酶免分析仪", "EUROIMMUN Medizinische Labordiagnostika AG", "欧蒙医学诊断（中国）有限公司"],
        ["11", "JQX2600229", "双水平正压通气治疗机", "ResMed Pty Ltd", "瑞思迈（北京）贸易有限公司"],
        ["12", "CQZ24002409", "超声软组织手术设备", "重庆知路者医疗科技有限公司", ""],
        ["13", "CQZ2500120", "半导体激光治疗机", "西安益都医疗电子科技有限公司", ""],
        ["14", "CQZ2600199", "生物安全柜", "上海轩文斯净化设备有限公司", ""],
        ["15", "CSZ2600040", "解脲脲原体核酸检测试剂盒（PCR-荧光探针法）", "深圳市新产业生物医工程股份有限公司", ""],
        ["16", "CQY2600263", "一次性使用无菌自毁注射器 带针", "广东因特圣医疗器械有限公司", ""],
        ["17", "CQX2501795", "硅酮腺医用胶", "广州迈普再生医学科技股份有限公司", ""],
        ["18", "CSX2600013", "肺炎克雷伯菌及3种（NDM、KPC和OXA-48）碳青霉烯耐药基因检测试剂盒（荧光PCR法）", "宁波建功生物技术有限公司", ""],
        ["19", "CQZ2401299", "颈动脉球囊支架", "苏州中天医疗器械科技有限公司", ""],
        ["20", "CQZ2401410", "卵裂培养液", "太平洋森赛科学仪器（济南）有限公司", ""],
        ["21", "CQZ2500179", "软组织修复支架", "北京天星医疗股份有限公司", ""],
        ["22", "CQZ2502415", "一次性使用静脉采血针", "浙江迈纳士智能诊断科技有限公司", ""],
        ["23", "JQZ2500025", "软性亲水接触镜", "晶硕光学股份有限公司", "瞳视界生物科技（江苏）有限公司"],
        ["24", "JQX2401457", "除颤监护仪", "SCHILLER MEDICAL", "薪火医疗设备（重庆）有限公司"],
        ["25", "CQZ2401241", "注射用特伐瞳明质酸钠凝胶", "浙江景兴医疗科技有限公司", ""],
        ["26", "CQZ2401722", "髋关节假体-球头", "北京市春立正达医疗器械股份有限公司", ""],
        ["27", "CQZ2402377", "聚醚醚酮颅骨修补系统", "江苏艾迪尔医疗科技股份有限公司", ""],
        ["28", "CQZ2500092", "弹性义齿基托材料", "珠海市科瑞迪医疗科技有限公司", ""],
        ["29", "CQZ2500540", "预冲式冲管注射器", "山东朱氏药业集团有限公司", ""],
        ["30", "JQZ2400509", "德尔塔可吸收颅颌面内固定系统", "Stryker Leibinger GmbH & Co KG", "史赛克（北京）医疗器械有限公司"]
      ]
    }
  ]
};
